<div class="app" (keydown)="handleKeyPressed($event)">
  @if (globalEnv.isActiveRequest()) {
    <div class="loader-spinner">
      <div>
        <i aria-hidden="true" class="icon-spinner"></i>
      </div>
    </div>
  }
  <router-outlet />
  @if (successMessage) {
    <div class="clearMessageBanner">
      <i aria-hidden="true" class="icon-close" style="cursor: pointer" (click)="closeSuccessMessage()"></i>
      <div class="iu-banner-message">
        <i aria-hidden="true" class="iu-banner-icon fa-lg fas fa-check"></i>
        <span class="iu-banner-message-text"> {{ successMessage.message }} </span>
      </div>
    </div>
  }
</div>

@if (loading()) {
  <iu-status-page-layout class="loading-page" [noMessage]="true" />
}
